import { useEffect } from 'react';

/** Sends marketing /signup and /login to the Business app. */
export function AppRedirect({ href, label }: { href: string; label: string }) {
  useEffect(() => {
    if (import.meta.env.MODE === 'test') return;
    window.location.replace(href);
  }, [href]);

  return (
    <section className="flex min-h-[calc(100vh-200px)] flex-1 items-center justify-center px-6 py-20">
      <div className="max-w-[480px] text-center">
        <h1 className="font-display mb-4 text-[2rem] font-extrabold text-ink">Continue in cevop</h1>
        <p className="mb-8 text-[1rem] leading-[1.7] text-ink-3">
          Accounts are created in the Business app, not on this website.
        </p>
        <a
          href={href}
          className="inline-flex items-center justify-center rounded-xl bg-brand px-7 py-3.5 font-semibold text-brand-on hover:bg-brand-hover"
        >
          {label}
        </a>
      </div>
    </section>
  );
}
